/**
 * Translate Globo/native product option labels and required-field messages
 * when the storefront language is not Hebrew.
 */
(function () {
  'use strict';

  var i18n = window.theme613I18n;
  if (!i18n) return;

  var locale = String(i18n.locale || '').toLowerCase();
  if (locale === 'he' || locale === 'he-il' || locale.indexOf('he-') === 0) return;

  var COLOR_NAMES = ['color', 'colour', 'צבע', 'couleur', 'colore', 'farbe'];
  var SIZE_NAMES = ['size', 'מידה', 'taille', 'taglia', 'größe', 'groesse'];
  var REQUIRED_HE = 'שדה זה הוא חובה';
  var REQUIRED_EN = 'this field is required';
  var TITLE_SELECTORS = [
    '.swatches-globo .swatch-globo-title',
    '.swatches-globo .globo-title',
    '.swatches-globo .name-option',
    '.swatches-globo [class*="title"]',
    '.globo-swatch-product-detail .label',
    '.globo-swatch-product-detail .title',
    'variant-radios legend.form__label',
    'fieldset.product-form__input legend.form__label'
  ].join(',');

  function normalize(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function isColorName(name) {
    var n = normalize(name);
    return COLOR_NAMES.some(function (label) {
      return n === label || n.indexOf(label) === 0;
    });
  }

  function isSizeName(name) {
    var n = normalize(name);
    return SIZE_NAMES.some(function (label) {
      return n === label || n.indexOf(label) === 0;
    });
  }

  function translateColorValue(value) {
    var key = normalize(value);
    if (i18n.colors && i18n.colors[key]) return i18n.colors[key];
    return value;
  }

  function translateTitle(text) {
    var raw = String(text || '').replace(/\u00a0/g, ' ').trim();
    if (!raw) return raw;

    var colon = raw.indexOf(':');
    var name = colon >= 0 ? raw.slice(0, colon).trim() : raw;
    var value = colon >= 0 ? raw.slice(colon + 1).trim() : '';
    var mappedName = name;

    if (isColorName(name)) mappedName = i18n.color;
    else if (isSizeName(name)) mappedName = i18n.size;

    if (value) return mappedName + ': ' + translateColorValue(value);
    return mappedName;
  }

  function translateTitles(root) {
    (root || document).querySelectorAll(TITLE_SELECTORS).forEach(function (el) {
      var next = translateTitle(el.textContent);
      if (next && next !== el.textContent.trim()) el.textContent = next;
    });
  }

  function isRequiredMessage(text) {
    var n = normalize(text);
    return n === normalize(REQUIRED_HE) || n === REQUIRED_EN || n.indexOf('field is required') !== -1;
  }

  function translateRequired(root) {
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (!isRequiredMessage(node.textContent)) continue;
      node.textContent = i18n.fieldRequired;
    }
  }

  function run(root) {
    translateTitles(root);
    translateRequired(root || document.body);
  }

  function init() {
    run();
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        run();
      });
    }
    var observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
